var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPetsLive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M22.981 13.033a26 26 0 0 1 1.635.208M27.705 13.813c1.112.38 1.765.845 1.765 1.348 0 1.281-4.24 2.318-9.471 2.318s-9.47-1.037-9.47-2.318c0-1.033 2.765-1.909 6.583-2.209M31.5 22.195c0 1.825-5.149 3.305-11.501 3.305S8.5 24.02 8.5 22.196M29.959 18.63c-1.989.987-5.705 1.652-9.96 1.652s-7.97-.665-9.958-1.652M29.47 15.618l2.03 6.777M8.5 22.395l2.029-6.777"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m23.512 14.61 1.912-2.327a.593.593 0 0 1 .858-.072l1.262 1.116a.647.647 0 0 1 .07.89l-2.294 2.76M16.495 17.158a.9.9 0 0 1-.01-.264l.393-3.363a.813.813 0 0 1 .897-.73l1.688.213c.442.056.756.472.703.93l-.393 3.363q-.001.017-.005.035"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M19.868 13.178a.8.8 0 0 1 .402-.314l1.609-.57a.8.8 0 0 1 1.023.522l.991 3.454c.143.437-.104.847-.526.997l-.303.107M20.91 17.32a1 1 0 0 1-.088-.189l-.751-2.284M13.79 16.686l-.525-1.556a.776.776 0 0 1 .455-.977l1.474-.533a.733.733 0 0 1 .942.47l1.054 3.13"
}))));
export default SvgPetsLive;